import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { initTextSize } from "@/features/preferences/text-size";
import { initI18n } from "@/i18n";
/*
 * `src/index.css` is generated and owned by the shadcn CLI — `init` wrote it and
 * `add` extends it. It pulls in Tailwind, `shadcn/tailwind.css` (the token set),
 * `tw-animate-css` and Inter. Do not hand-edit it; re-running the CLI will
 * overwrite whatever is there.
 */
import "@/index.css";
/*
 * AFTER `index.css`, deliberately. The shadcn CLI owns that file and rewrites
 * it; this one holds the viewer preferences (text size, reduced motion) that
 * must survive the next `shadcn add`. Importing it second also means its `html`
 * rule wins on equal specificity.
 */
import "@/styles/preferences.css";

/**
 * Entry point.
 *
 * i18n is initialised BEFORE the first render (§11.4 — "build i18n from the
 * first screen"). Doing it inside a component would give one frame in which
 * `t("btn.newInvoice")` returns the raw key, and on a slow phone that frame is
 * visible.
 *
 * The text size is applied for the same reason: reading it inside a component
 * leaves one frame at the default size, and on a slow phone that flash looks
 * like the app resetting the preference.
 */
initI18n();
initTextSize();

const container = document.getElementById("root");
if (container === null) {
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
